const NEWLINE = "\x0A"
const NEGRITO_ON = "\x1B\x45\x0D"
const NEGRITO_OFF = "\x1B\x45\x0A"
const FONT_NORMAL = "\x1D\x21\x00"
const FONT_MEDIO = "\x1D\x21\x01"
const FONT_GRANDE = "\x1D\x21\x11"
const NEGATIVO_ON = "\x1D\x42\x01"
const NEGATIVO_OFF = "\x1D\x42\x00"

function formatarDinheiro(valor) {
    return "R$ " + (valor || 0).toFixed(2).replace(".", ",")
}

function formatarNomeComQtd(quantidade, nome) {
    const qtd = Math.round(quantidade)
    return qtd > 1 ? `${qtd} X ${nome}` : nome
}

function formatarData(dataStr) {
    if (!dataStr) return ""
    const [data, hora] = dataStr.split(" ")
    const [ano, mes, dia] = data.split("-")
    return `${dia}/${mes}/${ano} Hora: ${hora}`
}

function formatarHora(dataStr) {
    if (!dataStr) return ""
    return dataStr.split(" ")[1] || ""
}

function htmlEsc(s) {
    return String(s)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\n/g, "<br>")
}

const FONTE_HTML = [
    { px: 13, linhaPx: 20, espacoPx: 8 },
    { px: 20, linhaPx: 28, espacoPx: 8 },
    { px: 24, linhaPx: 36, espacoPx: 16 },
]

function linhaEscPos(texto, config) {
    if (!config?.ativo || texto == null || texto === "") return ""

    const margemSup = NEWLINE.repeat(config.margemSuperior || 0)
    const margemInf = NEWLINE.repeat(config.margemInferior || 0)
    const margemEsq = " ".repeat(config.margemEsquerda || 0)
    const inicio = config.textoInicioLinha || ""
    const nivel = config.fonte || 0
    const fonteCmd = nivel >= 2 ? FONT_GRANDE : nivel >= 1 ? FONT_MEDIO : FONT_NORMAL
    const negritoOn = config.negrito ? NEGRITO_ON : ""
    const negritoOff = config.negrito ? NEGRITO_OFF : ""
    const negativoOn = config.negativo ? NEGATIVO_ON : ""
    const negativoOff = config.negativo ? NEGATIVO_OFF : ""

    const textoComPrefixo = String(texto)
        .split(/\r?\n/)
        .map((linha, indice) => (indice === 0 ? linha : margemEsq + inicio + linha))
        .join(NEWLINE)

    return (
        margemSup +
        fonteCmd +
        negativoOn +
        negritoOn +
        margemEsq +
        inicio +
        textoComPrefixo +
        negritoOff +
        negativoOff +
        NEWLINE +
        margemInf
    )
}
function linhaValorEscPos(label, valor, config) {
    if (!config?.ativo) return ""
    return linhaEscPos(`${label} ${valor}`, config)
}

function linhaHTML(texto, config) {
    if (!config?.ativo || texto == null || texto === "") return ""

    const nivel = Math.min(2, Math.max(0, config.fonte || 0))
    const { px, linhaPx, espacoPx } = FONTE_HTML[nivel]
    const inicio = config.textoInicioLinha || ""

    const style = [
        `margin:${(config.margemSuperior || 0) * linhaPx}px 0 ${
            (config.margemInferior || 0) * linhaPx
        }px ${(config.margemEsquerda || 0) * espacoPx}px`,
        `font-size:${px}px`,
        `font-weight:${config.negrito ? "bold" : "normal"}`,
        config.negativo
            ? "background-color:#000;color:#fff;padding:2px 4px;display:inline-block"
            : "padding:0",
    ].join(";")

    return `<p style="${style}">${htmlEsc(texto)}</p>`
}

function linhaValorHTML(label, valor, config) {
    if (!config?.ativo) return ""
    return linhaHTML(`${label} ${valor}`, config)
}

const rendererEscPos = {
    linha: linhaEscPos,
    linhaValor: linhaValorEscPos,
    separador: colunas => "_".repeat(colunas) + NEWLINE,
    separadorProduto: colunas => "-".repeat(colunas) + NEWLINE,
    espacoProduto: () => NEWLINE,
    avisoSimplificado: FONT_NORMAL + "* Pedido com cadastro simplificado *" + NEWLINE,
}

const rendererHTML = {
    linha: linhaHTML,
    linhaValor: linhaValorHTML,
    separador: colunas => `<p style="margin:0;padding:0">${"_".repeat(colunas)}</p>`,
    separadorProduto: colunas =>
        `<p style="margin:0;padding:0;font-size:13px;line-height:normal">${"-".repeat(
            colunas
        )}</p>`,
    espacoProduto: () => `<p style="margin:0;padding:0">&nbsp;</p>`,
    avisoSimplificado: `<p style="font-size:12px;margin:4px 0;padding:0;font-style:italic">* Pedido com cadastro simplificado *</p>`,
}

function aplicarPG(campoConfig, pg) {
    if (!pg || !campoConfig) return campoConfig
    return {
        ...campoConfig,
        negrito: pg.negrito || campoConfig.negrito,
        fonte: Math.max(campoConfig.fonte || 0, pg.fonte || 0),
        textoInicioLinha: pg.textoInicioLinha || "",
    }
}

// taxaEntregaOriginal (taxa cheia na criação do pedido) menos a taxa cobrada. 0 quando não houve
// desconto na entrega ou o pedido não tem a original (pedidos antigos, iFood, 99).
function calcularDescontoEntrega(pedido) {
    if (pedido.taxaEntregaOriginal == null) return 0
    const desconto = Number(pedido.taxaEntregaOriginal) - (Number(pedido.deliveryFee) || 0)
    return Number.isFinite(desconto) && desconto >= 0.005 ? desconto : 0
}

function removerAcentos(texto) {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

function gerarTexto(pedido, config, r) {
    console.log("obj do pedido =>", pedido)
    let t = ""
    const pg = config.parametrosGerais
    const colunas = pg?.colunas ?? 40
    const sep = r.separador(colunas)

    let temConteudoDesdeUltimoSep = false

    const l = (texto, campoConfig) => {
        const linha = r.linha(texto, aplicarPG(campoConfig, pg))
        if (linha) temConteudoDesdeUltimoSep = true
        return linha
    }

    const lv = (label, valor, campoConfig) => {
        const linha = r.linhaValor(label, valor, aplicarPG(campoConfig, pg))
        if (linha) temConteudoDesdeUltimoSep = true
        return linha
    }

    const addSep = () => {
        if (!temConteudoDesdeUltimoSep) return
        t += sep
        temConteudoDesdeUltimoSep = false
    }

    const isBuscarNoLocal = pedido.deliveryAddress?.streetName === "Buscar no local"
    const isSimplificado = pedido.customer?.email?.includes("sem_cadastro.sistema")

    t += sep

    const nomePlataforma = /react/i.test(pedido.plataforma || "") ? "Site" : pedido.plataforma || ""
    t += l(`#${pedido.id} (${nomePlataforma})`, config.idDoPedido)
    if (pedido.shortReference) {
        t += l(`#${pedido.shortReference}`, config.referencia)
    }
    if (pedido.type === "2" && pedido.mesa) {
        t += l(`Mesa: ${pedido.mesa}`, config.mesa)
    }
    t += l(`Data: ${formatarData(pedido.createdAt)}`, config.data)
    if (pedido.customer?.name !== "Anônimo") {
        t += l(`Cliente: ${pedido.customer?.name || ""}`, config.cliente)
    }
    t += l(
        `CPF: ${
            pedido.customer?.taxPayerIdentificationNumber || pedido.customer?.documentNumber || ""
        }`,
        config.cpf
    )
    if (pedido.customer?.phone) {
        t += l(`Telefone: ${pedido.customer.phone}`, config.telefone)
    }

    const labelEntrega = pedido.type === "1" ? "retirada" : "Entrega"
    t += l(
        `Previsão ${labelEntrega}: ${formatarHora(pedido.deliveryDateTime)}`,
        config.previsaoEntrega
    )

    if (isBuscarNoLocal) {
        t += l("CLIENTE SOLICITOU BUSCAR NO LOCAL", config.rua)
    } else {
        t += l(pedido.deliveryAddress?.streetName || "", config.rua)

        const compl = pedido.deliveryAddress?.complement
            ? ` Compl.: ${pedido.deliveryAddress.complement}`
            : ""
        if (pedido.deliveryAddress?.streetNumber) {
            t += l(`Número: ${pedido.deliveryAddress.streetNumber}${compl}`, config.numeroRua)
        }
        if (pedido.deliveryAddress?.neighborhood) {
            t += l(`Bairro: ${pedido.deliveryAddress.neighborhood}`, config.bairro)
        }
        const referenciaEndereco =
            pedido.deliveryAddress?.reference || pedido.deliveryAddress?.referencia
        if (referenciaEndereco) {
            t += l(`Referência: ${referenciaEndereco}`, config.referenciaEndereco)
        }

        const cep = pedido.deliveryAddress?.postalCode
            ? `\nCEP: ${pedido.deliveryAddress.postalCode}`
            : ""
        t += l(`${pedido.deliveryAddress?.city || ""}${cep}`, config.cidade)
    }

    if (isSimplificado && (config.avisoSimplificado?.ativo ?? true)) {
        t += r.avisoSimplificado
        temConteudoDesdeUltimoSep = true
    }

    const isConsumirNoLocal = pedido.type === "2" && !pedido.mesa
    if (isConsumirNoLocal) {
        t += l("CONSUMIR NO LOCAL", config.consumirNoLocal)
    }

    addSep()

    const linhaAposProduto = pg?.linhaAposProduto ?? false

    pedido.items?.forEach((item, indice) => {
        if (indice > 0) {
            t += r.espacoProduto()
        }

        if (item.nameCategory) {
            t += l(item.nameCategory, config.categoria)
        }

        t += l(formatarNomeComQtd(item.quantity, item.name), config.produto)

        item.subItems?.forEach(subItem => {
            if (subItem.nomeGrupoOpcoes) {
                t += l(subItem.nomeGrupoOpcoes, config.grupoDeOpcao)
            }
            t += l(` > ${formatarNomeComQtd(subItem.quantity, subItem.name)}`, config.opcao)
        })

        if (item.observations?.trim()) {
            t += l(`OBS.: ${item.observations.trim()}`, config.observacaoProduto)
        }

        if (linhaAposProduto) {
            t += r.separadorProduto(colunas)
        }
    })

    if (pedido.observations?.trim()) {
        t += l(`OBS.: ${pedido.observations.trim()}`, config.observacaoPedido)
    }

    addSep()

    const ehIfood = !!pedido.ifoodOrderUUID || /ifood/i.test(pedido.plataforma || "")
    const pagamento = (ehIfood && pedido.paymentMethods?.[0]) || pedido.payments

    t += lv("Pagamento:", pagamento?.name || "", config.pagamento)
    t += lv("Subtotal:", formatarDinheiro(pedido.subTotal), config.subtotal)
    const descontoEntrega = calcularDescontoEntrega(pedido)
    // Layout com "Detalhar desconto na entrega": taxa cheia, desconto e entrega cobrada.
    const temTaxaEntrega = pedido.deliveryFee != null && pedido.deliveryFee !== ""
    if (!temTaxaEntrega) {
    } else if (descontoEntrega > 0 && pg?.detalharDescontoEntrega) {
        t += lv(
            "Taxa de entrega:",
            formatarDinheiro(Number(pedido.taxaEntregaOriginal)),
            config.taxaDeEntrega
        )
        t += lv(
            "Desconto na entrega:",
            "-" + formatarDinheiro(descontoEntrega),
            config.taxaDeEntrega
        )
        t += l("----------", config.taxaDeEntrega)
        t += lv("Entrega:", formatarDinheiro(pedido.deliveryFee), config.taxaDeEntrega)
    } else {
        t += lv("Taxa de Entrega:", formatarDinheiro(pedido.deliveryFee), config.taxaDeEntrega)
    }
    if (Number(pedido.discountOrder) > 0)
        t += lv("Desconto:", formatarDinheiro(pedido.discountOrder), config.desconto)
    if (Number(pedido.taxaServico) > 0)
        t += lv("Taxa Adicional:", formatarDinheiro(pedido.taxaServico), config.taxaAdicional)
    const ehPagamentoDinheiro = (pagamento?.name || "").toLowerCase().includes("dinheiro")
    const trocoPara = pagamento?.changeFor
    const troco = trocoPara ? trocoPara - pedido.totalPrice : pagamento?.change
    if (ehPagamentoDinheiro && trocoPara) {
        t += lv("Troco para:", formatarDinheiro(trocoPara), config.trocoPara)
    }
    if (ehPagamentoDinheiro && troco) {
        t += lv("Troco:", formatarDinheiro(troco), config.troco)
    }
    t += lv("TOTAL:", formatarDinheiro(pedido.totalPrice), config.total)
    const valorCobrar =
        pagamento?.prepaid === true
            ? 0
            : Number(
                  pagamento?.cobrarDoCliente ??
                      (ehIfood ? pagamento?.value : undefined) ??
                      pedido.totalPrice
              ) || 0
    t += lv("Cobrar do Cliente:", formatarDinheiro(valorCobrar), config.cobrarDoCliente)

    addSep()

    t += l(pedido.merchant?.cnpj || "", config.cnpj)
    if (pedido.payments?.name === "PIX" && pedido.payments?.chavePix) {
        t += lv(
            "Chave PIX:",
            `(${pedido.payments.tipoChavePix || ""}) ${pedido.payments.chavePix}`,
            config.chavePix
        )
    }
    t += l(pedido.merchant?.name || "", config.nomeEstabelecimento)
    t += l(pedido.merchant?.phones || "", config.numeroEstabelecimento)

    return pg?.imprimirAcentuacao === false ? removerAcentos(t) : t
}

/**
 * @param {object} pedido
 * @param {object} config
 * @returns {string}
 */
export function gerarCorpoHTML(pedido, config) {
    return gerarTexto(pedido, config, rendererHTML)
}

/**
 * @param {object} pedido
 * @param {object} config
 * @returns {string}
 */
export function gerarTextoImpressao(pedido, config) {
    const pg = config.parametrosGerais
    const linhasPos = pg?.qtdLinhasPosImpressao ?? 0
    return "\n\n" + gerarTexto(pedido, config, rendererEscPos) + NEWLINE.repeat(linhasPos)
}

/**
 * @param {object} pedido
 * @param {object} config
 * @returns {string}
 */
export function gerarPreviewHTML(pedido, config) {
    const corpo = gerarTexto(pedido, config, rendererHTML)
    return (
        `<!DOCTYPE html><html><head>` +
        `<title>Preview Impressão #${pedido.shortReference || ""}</title>` +
        `<style>` +
        `body{background:#fff9c4;font-family:monospace;padding:16px;margin:0}` +
        `p{margin:0;line-height:1.4}` +
        `</style></head>` +
        `<body>${corpo}</body></html>`
    )
}
